import { useSearchParams } from "react-router";
import { PageTracker } from "@/components/analytics/page-tracker";
import { OnboardingFlow } from "@/components/auth/onboarding-flow";
import { useSession } from "@shared/client/session";
import { usePageTitle } from "@shared/client/view";
import { nameParts } from "@shared/lib/auth-shared";
import { EVENTS } from "@shared/lib/analytics";
import { parseSiteUrl } from "@shared/lib/url";
import { useT } from "@shared/client/locale";

export default function OnboardingPage() {
  usePageTitle(useT().auth.pageTitles.onboarding);
  // La garde de la route garantit une session sans onboarding terminé.
  const user = useSession()!.user;
  const metadata = user.user_metadata ?? {};

  // Le site saisi sur la landing revient par l'URL (Google) ou par les
  // métadonnées posées à l'inscription par e-mail.
  const [params] = useSearchParams();
  const site = params.get("site");
  const savedWebsite = typeof metadata.website === "string" ? metadata.website : "";
  const initialWebsite = parseSiteUrl(site ?? "") ?? parseSiteUrl(savedWebsite) ?? "";

  // Google fournit prénom et nom ; un compte plus ancien n'a que le nom complet.
  const { first, last } = nameParts({ ...metadata, full_name: [metadata.full_name, metadata.name].find((value) => typeof value === "string" && value.trim()) as string | undefined });
  const text = (value: unknown) => (typeof value === "string" ? value.trim() : "");

  return (
    <main>
      <PageTracker event={EVENTS.ONBOARDING_STARTED} />
      <OnboardingFlow
        email={user.email || ""}
        initialCompany={text(metadata.company)}
        initialFirstName={first}
        initialLastName={last}
        initialRole={text(metadata.role)}
        initialWebsite={initialWebsite}
      />
    </main>
  );
}
